import { render } from "./index.vue?vue&type=template&id=190133ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=190133ee&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190133ee"]])

export default __exports__